<template>
    <div class="tab-content card card-body shadow mb-0">
        <router-view />

        <div
            class="tab-pane active"
            :class="page == 'identificacao' ? 'active' : ''"
            v-if="page == 'identificacao'"
        >
            <Identificacao
                @submit="submit"
                @excluir="$emit('excluir')"
                :item="item"
                :localidades="localidades"
            />
        </div>
        <div
            class="tab-pane"
            :class="page == 'ingresso' ? 'active' : ''"
            v-if="page == 'ingresso'"
        >
            <Ingresso @submit="submit" :item="item" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'composicao' ? 'active' : ''"
            v-if="page == 'composicao'"
        >
            <Composicao :item="item" @atualizar="$emit('atualizar')" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'habitacao' ? 'active' : ''"
            v-if="page == 'habitacao'"
        >
            <Habitacao :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'educacao' ? 'active' : ''"
            v-if="page == 'educacao'"
        >
            <Educacao :item="item" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'financeiro' ? 'active' : ''"
            v-if="page == 'financeiro'"
        >
            <Financeiro :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'saude' ? 'active' : ''"
            v-if="page == 'saude'"
        >
            <Saude :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'outras_caracteristicas' ? 'active' : ''"
            v-if="page == 'outras_caracteristicas'"
        >
            <Caracteristicas :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'convivencia' ? 'active' : ''"
            v-if="page == 'convivencia'"
        >
            <Convivencia :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'programasServicos' ? 'active' : ''"
            v-if="page == 'programasServicos'"
        >
            <ProgramasServicos :item="item" @submit="submit" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'ocorrencias' ? 'active' : ''"
            v-if="page == 'ocorrencias'"
        >
            <Ocorrencias :item="item" />
        </div>
        <div
            class="tab-pane"
            :class="page == 'anexo' ? 'active' : ''"
            v-if="page == 'anexo'"
        >
            <Anexo :item="item" />
        </div>
    </div>
    <!-- <div class="card-footer">
			<div class="alert alert-info small">
				<p>
					<strong>*IMPORTANTE:</strong>
					Sempre que as informações importadas do Cadastro Único forem atualizadas um
					encaminhamento será gerado automaticamente, orientando o usuário a se dirigir a
					Caixa Econômica Federal para realizar sua atualização cadastral.
				</p>
			</div>
		</div> -->
</template>
<script>
import Identificacao from "./Abas/Identificacao";
import Ingresso from "./Abas/FormaIngresso";
import Composicao from "./Abas/Composicao";
import Financeiro from "./Abas/Financeiro";
import Habitacao from "./Abas/Habitacao";
import Caracteristicas from "./Abas/Caracteristicas";
import Convivencia from "./Abas/Convivencia";
import ProgramasServicos from "./Abas/ProgramasServicos";
import Ocorrencias from "./Abas/Ocorrencias";
import Saude from "./Abas/Saude";
import Educacao from "./Abas/Educacao";
import Anexo from "./Abas/Anexo";
export default {
    props: ["item", "page", "localidades"],
    components: {
        Educacao,
        Identificacao,
        Ingresso,
        Composicao,
        Financeiro,
        Habitacao,
        Caracteristicas,
        Convivencia,
        ProgramasServicos,
        Ocorrencias,
        Saude,
        Anexo,
    },
    methods: {
        submit() {
            this.$emit("submit");
        },
    },
};
</script>
